import { Redirect, Route } from "react-router-dom/cjs/react-router-dom";
import { logout } from "services/auth/auth.service";
import { getUser } from "services/auth/auth.service";

export function PrivateRoute({ component: Component, ibTypesAllowed, ...rest }) {
  const session = getUser();

  if (session && !ibTypesAllowed.includes(session.ibType)) logout(false);

  return (
    <Route
      {...rest}
      render={(props) =>
        session && ibTypesAllowed.includes(session.ibType) ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/authentication/sign-in" }} />
        )
      }
    />
  );
}
